"use strict";var _interopRequireDefault = require("D:\\work\\svn\\\u5BB6\u7528\u540E\u53F0\\branches\\20240430-1.5.0\\node_modules\\@babel\\runtime/helpers/interopRequireDefault");Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;require("core-js/modules/es6.function.name");







































































































































var _user = require("@/utils/user");
var _formatter = require("@/utils/formatter");
var _VoiceApply = _interopRequireDefault(require("@/components/VoiceApply"));
var _Intention = _interopRequireDefault(require("@/components/Intention"));
var _Function = _interopRequireDefault(require("@/components/Function")); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = { components: { Apply: _VoiceApply.default, Function: _Function.default, Intent: _Intention.default }, data: function data() {return { tableData: [], // 列表数据
      organizationList: [], robotId: '', insId: '', newadd: false, modOrg: false, title: '', detail: '', searchData: { functionId: '', standardSlot: '', replyType: '', merchantName: '', page: 1, // 页码条数
        rows: 10 }, pageData: { page: 1, rows: 10, total: 0, pages: 1 }, addData: { id: '', content: '', functionId: 0, voiceAppId: 0, merchantName: '', replyType: '', standardSlot: '', functionSlot: '' }, rules: { functionId: [{ required: true, validator: this.handleValidFun, trigger: 'blur' }], merchantName: [{ required: true, message: '请输入语音应用', trigger: 'change' }], replyType: [{ required: true, message: '请输入回复类别', trigger: 'change' }], content: [{ required: true, message: '请输入语音内容', trigger: 'blur' }] }, // 表格列
      tableColumns: [{ prop: 'merchantName', label: '语音应用', isShow: true }, { prop: 'replyType', label: '回复类别', isShow: true }, { prop: 'deviceTypeCode', label: '设备类别', isShow: true }, { prop: 'standardSlot', label: '程序', isShow: true }, { prop: 'content', label: '语音内容', isShow: true }, { prop: 'createTime', label: '创建时间', formatter: _formatter.dateFormatter, isShow: true }, { prop: 'updateTime', label: '更新时间', formatter: _formatter.dateFormatter, isShow: true }], defaultProps: { children: 'child', label: 'insName' } };}, mounted: function mounted() {var self = this;self.init();}, methods: { init: function init() {var self = this;self.getData('/api/voiceReply', self.searchData, function (res) {self.tableData = res.list;self.pageData.page = res.pageNum;self.pageData.total = res.total;});}, getOrganziationList: function getOrganziationList() {var self = this;self.getData('/api/institution/dropList/0', {}, function (res) {self.organizationList = res;});}, checkPermission: _user.checkPermission, resetFun: function resetFun() {// 重置
      this.searchData.standardSlot = '';this.searchData.functionId = '';this.searchData.replyType = '';this.searchData.merchantName = '';this.init();}, searchFun: function searchFun() {// 搜索事件
      this.searchData.page = 1;this.init();},
    handleSizeChange: function handleSizeChange(val) {// 分页条数
      this.searchData.rows = val;
      this.searchData.page = 1;
      this.init();
    },
    handleCurrentChange: function handleCurrentChange(val) {// 分页页码
      this.searchData.page = val;
      this.init();
    },
    handleApplyMsg: function handleApplyMsg(intention) {
      var self = this;
      console.log('intention', intention);
      self.addData.voiceAppId = intention.id;
      self.addData.merchantName = intention.name;
      self.addData.slot = intention.slot;
    },
    handleSelectApply: function handleSelectApply() {
      this.$refs.applyRef.handleShow = true;
    },
    handleIntentMsg: function handleIntentMsg(intention) {
      var self = this;
      self.addData.replyType = intention.intentCode;
    },
    handleSelectIntent: function handleSelectIntent() {
      this.$refs.intentRef.handleShow = true;
    },

    handleFunctionMsg: function handleFunctionMsg(fun) {
      var self = this;
      self.addData.functionId = fun.id;
      self.addData.functionSlot = fun.standardSlot;
    },
    handleSelectFunction: function handleSelectFunction() {
      this.$refs.functionRef.handleShow = true;
    },
    handleGetDetail: function handleGetDetail(id) {
      var self = this;
      self.getData('/api/voiceReply/' + id, {}, function (res) {
        self.addData = res;
        self.addData.functionSlot = res.standardSlot;
      });
    },
    handleValidFun: function handleValidFun(rules, value, callBack) {
      var self = this;
      if (self.addData.replyType === 'PROGRAM' && !self.addData.functionId) {
        callBack(new Error('请输入特定程序'));
      } else {
        callBack();
      }
    },
    addFun: function addFun() {// 新增
      this.title = '新增';
      this.newadd = true;
    },
    closeDiglog: function closeDiglog() {// 关闭弹出层
      this.$refs['addForm'].resetFields();
      this.cleanData();
      this.newadd = false;
      this.newadd2 = false;
    },
    updateMenu: function updateMenu(id) {// 修改操作
      this.title = '修改';
      var self = this;
      self.newadd = true;
      self.handleGetDetail(id);
      console.log('item', self.addData);
      /* self.addData = {
                                           id: item.id,
                                           functionId: item.functionId,
                                           functionTypeId: item.functionTypeId,
                                           voiceAppId: item.voiceAppId,
                                           replyType: item.replyType,
                                           slot: item.slot,
                                           standardSlot: item.standardSlot,
                                           content: item.content,
                                           content: item.content
                                         } */
    },
    onSubmit: function onSubmit() {// 新增提交操作
      var self = this;
      console.log('intention', self.addData);
      console.log('**', self.$refs.addForm);
      self.$refs.addForm.validate(function (valid) {
        console.log('valid', valid);
        if (valid) {
          self.postData('/api/voiceReply', self.addData, function (res) {
            self.$message({
              message: '添加成功!',
              type: 'success' });

            self.onCencal();
            self.searchData.page = 1;
            self.init();
          });
        } else {
          return false;
        }
      });
    },
    delMenu: function delMenu(delId) {// 删除操作
      var self = this;
      self.$confirm('确定删除该记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true }).
      then(function () {
        self.delData('/api/voiceReply/' + delId, {}, function (res) {
          self.$message({
            message: '删除成功!',
            type: 'success' });

          self.searchData.page = 1;
          self.init();
        });
      }).catch(function () {});
    },
    onCencal: function onCencal() {// 关闭弹出框
      this.$refs.addForm.resetFields();
      this.cleanData();
      this.newadd = false;
    },
    cleanData: function cleanData() {// 清理输入的数据
      this.addData = {
        id: '',
        replyType: '',
        functionId: 0,
        voiceAppId: 0,
        content: '',
        standardSlot: '',
        slot: '' };

    },
    openOrgDialog: function openOrgDialog(robotId) {
      var self = this;
      self.robotId = robotId;
      self.getIns(robotId);
      self.getOrganziationList();
      self.modOrg = true;
    },
    checkFn: function checkFn(node, data) {
      var currKey = node.id;
      this.$refs.orgTree.setCheckedKeys([currKey]);
      this.insId = currKey;
    } } };exports.default = _default;